<script setup lang="ts">
defineProps<{
  title?: string
}>()
</script>

<template>
  <section class="space-y-2.5">
    <p v-if="title || $slots.title" class="text-sm font-semibold text-foreground">
      <slot name="title">{{ title }}</slot>
    </p>
    <slot />
  </section>
</template>
